/** @file Positions a popup menu at a point, flipping and clamping so it stays inside the viewport. */
import { clamp } from '@pose2d/math/clamp';

/** A 2-D point in CSS pixels. */
export interface Point {
  x: number;
  y: number;
}

/** A width and height in CSS pixels. */
export interface Size {
  width: number;
  height: number;
}

/** One axis: keep `at`, flip so the far edge sits on `at` when it overflows, then clamp with `margin`. */
function placeAxis(at: number, length: number, room: number, margin: number): number {
  const flipped = at + length + margin > room ? at - length : at;
  return clamp(flipped, margin, Math.max(margin, room - length - margin));
}

/** Top-left corner for a menu of `size` opened at `anchor` inside `viewport`. */
export function placeMenu(anchor: Point, size: Size, viewport: Size, margin = 4): Point {
  return { x: placeAxis(anchor.x, size.width, viewport.width, margin), y: placeAxis(anchor.y, size.height, viewport.height, margin) };
}
